"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("../../scss/cookieConsentModalBody.scss");
require("react-toggle/style.css"); // for ES6 modules
const react_1 = __importDefault(require("react"));
const CookieConsentItemChoice_1 = __importDefault(require("./CookieConsentItemChoice"));
const useCookiesConsent_1 = require("../../hooks/useCookiesConsent");
const useMobileDetect_1 = __importDefault(require("../../hooks/useMobileDetect"));
function CookieConsentModalBody() {
    var _a, _b;
    const { config, intlLang } = (0, useCookiesConsent_1.useCookiesConsent)();
    const isMobile = (0, useMobileDetect_1.default)().isMobile();
    return (react_1.default.createElement("div", { className: `cookie-consent-modal-body ${isMobile && "mobile"}` },
        react_1.default.createElement("div", { className: "cookie-consent-description" },
            react_1.default.createElement("p", null, (_a = config.descriptionFull) === null || _a === void 0 ? void 0 : _a[intlLang])),
        react_1.default.createElement("div", { className: "cookie-consent-modal-list" }, (_b = config.cookieConsentPreferences) === null || _b === void 0 ? void 0 : _b.map((item, index) => (react_1.default.createElement(CookieConsentItemChoice_1.default, { key: `cookie-consent-item-choice-${index}`, cookieConsentPreferenceItem: item }))))));
}
exports.default = CookieConsentModalBody;
//# sourceMappingURL=CookieConsentModalBody.js.map